<!-- ws:rollout: same shell / rows / status pill as the row detail panels. The respond flow
     (PDT-32072, AC-08: note + documents for a pended request) is unchanged. -->
<payarc-dialog-shell title="Request details" (closed)="closeAction()">
  <div class="rqd-top" *ngIf="data.status">
    <payarc-status-badge [status]="data.status"></payarc-status-badge>
  </div>

  <payarc-detail-card [flat]="true" [rows]="detailRows"></payarc-detail-card>

  <!-- PDT-32072 (AC-08): respond to a pended request - what Risk asked for + upload/note form -->
  <section class="rqd-respond" *ngIf="data.can_respond">
    <h3 class="rqd-label">Submit your response</h3>

    <payarc-detail-card *ngIf="requestedRows.length" [flat]="true" [rows]="requestedRows"></payarc-detail-card>

    <textarea class="pa-input rqd-note" rows="3" aria-label="Response note"
              placeholder="Add a note (optional when files are attached)"
              [(ngModel)]="responseNote" [disabled]="submitting"></textarea>

    <div class="rqd-files">
      <input #responseFileInput type="file" multiple hidden
             accept=".pdf,.jpg,.jpeg,.png,.gif,.doc,.docx,.xls,.xlsx,.csv,.txt"
             (change)="onFilesSelected($event)">
      <button type="button" payarcButton="secondary" [disabled]="submitting" (click)="responseFileInput.click()">
        Attach documents
      </button>

      <ul class="rqd-chips" *ngIf="responseFiles.length > 0" aria-label="Attached documents">
        <li class="rqd-chip" *ngFor="let file of responseFiles; let i = index">
          <span class="rqd-chip__name">{{ file.name }}</span>
          <button type="button" class="rqd-chip__remove" [disabled]="submitting" (click)="removeFile(i)"
                  [attr.aria-label]="'Remove ' + file.name">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7l10 10M17 7L7 17" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>
          </button>
        </li>
      </ul>
    </div>

    <payarc-inline-alert variant="bad" *ngIf="responseError">{{ responseError }}</payarc-inline-alert>
  </section>

  <div footer class="rqd-footer">
    <button type="button" payarcButton="secondary" (click)="closeAction()">Close</button>
    <button *ngIf="data.can_respond" type="button" payarcButton="primary" [disabled]="!canSubmit()" (click)="submitResponse()">
      <span class="rqd-spinner" *ngIf="submitting" aria-hidden="true"></span>
      {{ submitting ? 'Submitting…' : 'Submit response' }}
    </button>
  </div>
</payarc-dialog-shell>
